
import React from 'react';

const InvestmentBenefits: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-line-chart-line',
      title: 'Strong Returns',
      description: 'Target 15-25% annual returns with our proven glamping development model and strategic location selection.',
      stats: '15-25% ROI'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Diversified Portfolio',
      description: 'Spread risk across multiple properties and markets while benefiting from the growing outdoor hospitality sector.',
      stats: '6+ Locations'
    },
    {
      icon: 'ri-team-line',
      title: 'Expert Management',
      description: 'Our experienced team handles all aspects of development, operations, and guest experience management.',
      stats: '20+ Years Experience'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainable Impact',
      description: 'Invest in eco-friendly developments that preserve natural beauty while generating sustainable income.',
      stats: '100% Eco-Friendly'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Passive Income',
      description: 'Enjoy regular distributions from rental income while we handle day-to-day operations and maintenance.',
      stats: 'Monthly Distributions'
    },
    {
      icon: 'ri-trending-up-line',
      title: 'Market Growth',
      description: 'Capitalize on the rapidly expanding glamping market, projected to grow 12.5% annually through 2028.',
      stats: '12.5% Market Growth'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Invest in Glamping with OED?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our investment opportunities combine the stability of real estate with the growth potential 
            of the booming outdoor hospitality market.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-center w-16 h-16 bg-emerald-100 rounded-lg mb-6">
                <i className={`${benefit.icon} text-2xl text-emerald-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 mb-4">{benefit.description}</p>
              <div className="text-emerald-600 font-semibold">{benefit.stats}</div>
            </div>
          ))}
        </div>

        {/* Investment Highlights */}
        <div className="mt-16 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl p-8 text-white">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold mb-2">$2.5M+</div>
              <div className="text-emerald-100">Total Investment Raised</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">95%</div>
              <div className="text-emerald-100">Average Occupancy Rate</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">150+</div>
              <div className="text-emerald-100">Satisfied Investors</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">8</div>
              <div className="text-emerald-100">Active Properties</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentBenefits;
